import { render, staticRenderFns } from "./resourceCategoryDetail.vue?vue&type=template&id=474c098a"
import script from "./resourceCategoryDetail.vue?vue&type=script&lang=js"
export * from "./resourceCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports